module.exports = __webpack_public_path__ + "static/media/termsCondition.d64aa460.svg";